import React, { useState } from 'react';
import { LibraryItem } from './types';
import { videoEmbedUrl } from '../squads/classroom/aiCreation';
import './LibraryMedia.css';
import GameCardMedia from './GameCardMedia';

type MediaItem = Pick<LibraryItem, 'contentType' | 'title' | 'displayAssetUrl' | 'shotBatch' | 'game' | 'model3d' | 'previewAssetUrl'>;

export default function LibraryMedia({ item }: { item: MediaItem }) {
  const [selectedId, setSelectedId] = useState('');
  const videos = item.shotBatch?.videos || [];
  const selected = videos.find(video => video.id === selectedId) || videos[0];
  const isVideo = item.contentType === 'movie' || item.contentType === 'shot_batch' || (item.contentType === 'model_3d' && item.model3d?.mediaType === 'video');
  const url = item.contentType === 'shot_batch' ? selected?.url : item.displayAssetUrl;
  const embed = isVideo && url ? videoEmbedUrl(url) : null;
  if (item.contentType === 'game') return <GameCardMedia title={item.title} game={item.game} previewUrl={item.displayAssetUrl} />;
  return <div className="library-media-player">
    {!url ? <span>No media yet</span> : item.contentType === 'audio' ? <audio src={url} controls preload="metadata" aria-label={item.title} /> : isVideo ? embed
      ? <iframe key={url} src={embed} title={selected?.title || item.title} allow="fullscreen; encrypted-media" allowFullScreen />
      : <video key={url} src={url} poster={selected?.posterUrl || item.previewAssetUrl} controls playsInline preload="metadata" aria-label={selected?.title || item.title} />
      : <img src={url} alt={item.title} loading="lazy" />}
    {item.contentType === 'shot_batch' && <div className="library-shot-playlist" role="group" aria-label="Shot batch videos">
      {videos.map((video, index) => <button type="button" key={video.id} aria-pressed={selected?.id === video.id} onClick={() => setSelectedId(video.id)}>{index + 1}. {video.title}</button>)}
    </div>}
  </div>;
}
